import { v4 as uuid } from "uuid";

import { Destination } from "../models/destination";
import { JobMode } from "../models/job.mode";
import { Location } from "../models/location";
import { Material } from "../models/material";
import { ItemJob } from "../models/sales";
import { ServiceBooking } from "../models/service.booking";

const getFormattedMaterial = (
  service: ServiceBooking,
  quantity: number,
  mode?: string,
  destination?: Destination,
  destinationResidence?: Location,
  modeDestination?: JobMode,
  jobId?: number,
  itemJobId?: number | string
) => {
  const materialToAdd: Material = {
    serviceBooking: {
      id: service.id,
      code: service.code,
      companyId: service.companyId,
      isItem: service.isItem,
      name: service.name,
      volume: service.volume,
      price: service?.price,
    },
    quantity,
    price: service.price ? Number(service.price) : 0,
    uuid: uuid(),
    volume: service.volume ? Number(service.volume) : 0,
    jobId,
    itemJobId,
    packingMaterialId: service.id,
    mode,
    destination,
    destinationId: destination && destination?.id ? destination?.id : null,
    destinationResidence,
    destinationResidenceId:
      destinationResidence && destinationResidence?.id ? destinationResidence?.id : null,
    modeDestination,
    modeDestinationId: modeDestination && modeDestination?.id ? modeDestination.id : null,
  };

  return materialToAdd;
};

const formatAllMaterialsFromItem = (
  serviceBookings: ServiceBooking[],
  itemJob: ItemJob,
  quantity?: number
) => {
  const allMaterials: Material[] = [];

  if (serviceBookings && serviceBookings?.length > 0) {
    serviceBookings?.forEach((packingMaterial) => {
      const { mode, destination, destinationResidence, modeDestination, jobId, id, uuid } =
        itemJob || {};

      const materialToAdd = getFormattedMaterial(
        packingMaterial,
        quantity || 1,
        mode,
        destination,
        destinationResidence,
        modeDestination,
        jobId,
        id || uuid
      );

      allMaterials.push(materialToAdd);
    });
  }

  return allMaterials;
};

export default formatAllMaterialsFromItem;
